module.exports = __webpack_public_path__ + "static/media/appcademix.d6561075.png";